import React from 'react';
export function WhySection() {
  return <section className="bg-cream px-4 py-6 sm:px-6" data-id="element-165" data-mp="h56iq6gptrl6">
      <div className="mx-auto max-w-2xl space-y-4" data-id="element-166" data-mp="13uqcxu0f2nkp">
        <article className="rounded-xl border border-sage/40 bg-white p-4 shadow-sm" data-id="element-167" data-mp="13t6zsca24sn5">
          <h2 className="font-heading text-lg font-extrabold uppercase leading-tight text-petrol sm:text-2xl" data-id="element-168" data-mp="18t1pwdm0de75">
            What if your daily care tools were already ready?
          </h2>
          <p className="mt-2 text-sm leading-snug sm:text-base" data-id="element-169" data-mp="1ijeag5ttp7da">
            You already know how to provide care. The problem is having to
            constantly organize routines, schedules, notes, appointments and
            everyday responsibilities. What needs to be done today? What needs to
            be tracked or documented? What should the next caregiver know?
            Instead of relying on scattered notes and memory, CAREGIVER READY™
            gives you ready-to-use resources covering 6 essential areas of
            everyday care organization.
          </p>
          <p className="mt-2 font-heading text-sm font-bold uppercase text-sage" data-id="element-170" data-mp="2igool09kkbrb">
            Choose. Organize. Record. Communicate.
          </p>
        </article>

        <article className="rounded-xl border border-sage/40 bg-white p-4 shadow-sm" data-id="element-171" data-mp="28ptsz5afnzt7">
          <h2 className="font-heading text-lg font-extrabold uppercase leading-tight text-petrol sm:text-2xl" data-id="element-172" data-mp="28nh8akdajbcg">
            😩 Stop starting every care day from scratch
          </h2>
          <p className="mt-2 text-sm leading-snug sm:text-base" data-id="element-173" data-mp="31ceswu4z5k8d">
            Your time should be spent providing care — not rebuilding schedules,
            checklists and notes every day. CAREGIVER READY™ brings everything
            together. Daily plans • Personal care routines • Meals & hydration •
            Mobility & safety • Care notes • Handoffs Everything is organized so
            you can find the right resource, use it and keep the day structured.
          </p>
          <p className="mt-2 font-heading text-sm font-bold uppercase text-sage" data-id="element-174" data-mp="1bxzx5pvjgx3d">
            Less planning. More organized care.
          </p>
        </article>

        <article className="rounded-xl bg-petrol p-4 text-white shadow-sm" data-id="element-175" data-mp="1igctbujbt55d">
          <h2 className="font-heading text-lg font-extrabold uppercase leading-tight sm:text-2xl" data-id="element-176" data-mp="14g20ilyghghk">
            ⏱️ Less organization. More ready-to-use tools.
          </h2>
          <p className="mt-2 text-sm leading-snug text-cream/90 sm:text-base" data-id="element-177" data-mp="18fu4smgth0h4">
            Need a daily care planner? It’s ready. Need a routine checklist? It’s
            ready. Meals, hydration, safety, observations or handoffs? They’re
            organized too.
          </p>
          <p className="mt-2 font-heading text-sm font-bold uppercase text-gold" data-id="element-178" data-mp="ktnl32y15wb2">
            Open the system. Choose the tool. Organize the day.
          </p>
        </article>
      </div>
    </section>;
}